import { Box, Card, ListItemText, Typography } from '@mui/material';
import { Iconify } from '../iconify';
import { ColorType } from 'src/types/common';

type OwnProps = {
  type: ColorType;
  cardType?: ColorType;
  icon: string;
  title: string;
  description?: string;
  sx?: object;
  dataTestId?: string;
};

const CardWithColorIcon = ({
  type,
  title,
  description,
  icon,
  sx,
  cardType,
  dataTestId,
}: OwnProps) => {
  return (
    <Card
      data-test-id={dataTestId}
      sx={(theme) => ({
        alignItems: 'center',
        display: 'flex',
        ...sx,
        background: cardType ? theme.palette[cardType].lighter : 'inherit',
      })}
    >
      <Box
        component="span"
        sx={(theme) => ({
          background: theme.palette[type].lighter,
          p: 1,
          m: 1,
          mr: 2,
          borderRadius: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        })}
      >
        <Iconify
          icon={icon}
          width={25}
          sx={(theme) => ({
            color: theme.palette[type].dark,
          })}
        />
      </Box>

      <ListItemText
        disableTypography
        primary={<Typography variant="subtitle2">{title}</Typography>}
        secondary={
          description ? (
            <Typography variant="body2" color="textDisabled">
              {description}
            </Typography>
          ) : (
            ''
          )
        }
      />
    </Card>
  );
};

export default CardWithColorIcon;
